<div class="full-width" [style.height]="height" *ngIf="center !== null">
    <google-map height="100%" width="100%" class="full-width" [center]="center" [options]="options" [mapId]="mapId">
        <map-advanced-marker [position]="center" [content]="markerContent" />
    </google-map>
</div>
